import Form from "@ant-design/compatible/es/form";
import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import RightSideIcon from "@impero-com/common/components/rightSideIcon";
import { t } from "@impero-com/common/utils/i18n";
import { Button, CardFooter, FormSubtitle, FormTitle } from "@impero-com/ui";

import orgInactive from "img/org-inactive.svg";

import "main.css";

import { useOrgDisplayInfo } from "../../utils/queries/useOrgDisplayInfoSuspenseQuery";

const FormItem = Form.Item;

function DisabledOrg() {
    const orgCookie = useOrgDisplayInfo();

    const reloadPage = () => {
        window.location.reload();
    };

    return (
        <FormCardContainer
            rightSide={
                <RightSideIcon
                    icon={orgInactive}
                    customImages={true}
                    orgCookie={orgCookie}
                />
            }
        >
            <FormTitle title={t("Login_DisabledOrg")} />
            <FormSubtitle subtitle={t("Login_DisabledOrgSubtitle")} />
            <FormCard>
                <FormItem>
                    <Button
                        id="login-disabled-org"
                        variant="primary"
                        onClick={reloadPage}
                        block
                    >
                        {t("Login_DisabledOrgReload")}
                    </Button>
                </FormItem>
            </FormCard>
            <CardFooter>
                <a href={`https://impero.com/get-in-touch/`}>
                    {t("Login_DisabledOrgContactUs")}
                </a>
            </CardFooter>
        </FormCardContainer>
    );
}

export { DisabledOrg };
